var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "availability" } }, [
    _c("div", { staticClass: "material-icons time-icon" }, [
      _vm._v("event_available"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "header", on: { click: _vm.changeVisible } }, [
        _c("div", { staticClass: "header-titles" }, [
          _c("span", { staticClass: "header-title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.receivedAppointInterval"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "header-sub-title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.receivedAppointIntervalDesc"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.visible
          ? _c("div", { staticClass: "material-icons" }, [
              _vm._v("expand_less"),
            ])
          : _c("div", { staticClass: "material-icons" }, [
              _vm._v("expand_more"),
            ]),
      ]),
      _vm._v(" "),
      _vm.visible
        ? _c("div", [
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("calendar.interimTime"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-label" }, [
                _vm._v(_vm._s(_vm.$t("calendar.interimTimeDesc"))),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "5px" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.setting.isBufferTimeMinute,
                      expression: "setting.isBufferTimeMinute",
                    },
                  ],
                  staticClass: "input-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.setting.isBufferTimeMinute)
                      ? _vm._i(_vm.setting.isBufferTimeMinute, null) > -1
                      : _vm.setting.isBufferTimeMinute,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.setting.isBufferTimeMinute,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.setting,
                              "isBufferTimeMinute",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.setting,
                              "isBufferTimeMinute",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.setting, "isBufferTimeMinute", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.setting.bufferTimeMinute,
                      expression: "setting.bufferTimeMinute",
                    },
                  ],
                  staticClass: "input-number",
                  attrs: {
                    type: "number",
                    disabled: !_vm.setting.isBufferTimeMinute,
                    min: "1",
                  },
                  domProps: { value: _vm.setting.bufferTimeMinute },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.setting,
                        "bufferTimeMinute",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("report.minute")))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section bottom" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("calendar.dayMaxRes"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-label" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("calendar.dayMaxResDesc")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "5px" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.setting.isMaxBookingCountPerDay,
                      expression: "setting.isMaxBookingCountPerDay",
                    },
                  ],
                  staticClass: "input-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.setting.isMaxBookingCountPerDay)
                      ? _vm._i(_vm.setting.isMaxBookingCountPerDay, null) > -1
                      : _vm.setting.isMaxBookingCountPerDay,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.setting.isMaxBookingCountPerDay,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.setting,
                              "isMaxBookingCountPerDay",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.setting,
                              "isMaxBookingCountPerDay",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.setting, "isMaxBookingCountPerDay", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.setting.maxBookingCountPerDay,
                      expression: "setting.maxBookingCountPerDay",
                    },
                  ],
                  staticClass: "input-number",
                  attrs: {
                    type: "number",
                    disabled: !_vm.setting.isMaxBookingCountPerDay,
                    min: "1",
                  },
                  domProps: { value: _vm.setting.maxBookingCountPerDay },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.setting,
                        "maxBookingCountPerDay",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("report.hour")))]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }